import React from 'react';
import CardItem from '../card/CardItem';
import CardName from '../card/CardName';

const CardList = props => {
  return (
    <>
      {props.query && (
        <h2 className="text-lg font-bold">Resultados para "{props.query}"</h2>
      )}
      <div
        className={`grid ${
          props.showCards
            ? 'grid-cols-1 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-4'
            : 'grid-cols-1 gap-y-4'
        }`}>
        {props.showCards
          ? props.cards.map(card => (
              <CardItem key={card.id} card={card}></CardItem>
            ))
          : props.cards.map(card => (
              <CardName key={card.id} card={card}></CardName>
            ))}
      </div>
    </>
  );
};

export default CardList;
